 
<template>
  <div class="float-right flex-row-reverse">
    <ul
      v-show="pager.pages && pager.pages.length"
      class="pagination"
      :style="ulStyles"
    >
      <li
        class="page-item first"
        :class="{ disabled: pager.currentPage === 1 }"
        :style="liStyles"
        v-show="pager.pages.length > 1"
      >
        <v-btn
          class="mr-2"
          :height="34"
          :width="34"
          fab
          small
          color="white"
          @click="changePage(1)"
          :disabled="pager.currentPage === 1"
          :style="aStyles"
        >
          <v-icon small color="rgba(0, 0, 0, 0.54)">fa-chevron-left</v-icon>
          <v-icon small color="rgba(0, 0, 0, 0.54)">fa-chevron-left</v-icon>
        </v-btn>
      </li>
      <li
        class="page-item previous"
        :class="{ disabled: pager.currentPage === 1 }"
        :style="liStyles"
        v-show="pager.pages.length > 1"
      >
        <v-btn
          class="page-link"
          :height="34"
          :width="34"
          fab
          small
          color="white"
          @click="changePage(pager.currentPage - 1)"
          :disabled="pager.currentPage === 1"
          :style="aStyles"
        >
          <v-icon small color="rgba(0, 0, 0, 0.54)">fa-chevron-left</v-icon>
        </v-btn>
      </li>
      <li
        v-for="page in pager.pages"
        :key="page"
        class="page-item page-number"
        :class="{ active: pager.currentPage === page }"
        :style="liStyles"
      >
        <v-btn
          class="mr-2 ml-2"
          :height="34"
          :width="34"
          fab
          small
          :color="pager.currentPage === page ? 'primary' : 'white'"
          @click="changePage(page)"
          :style="aStyles"
          >{{ page }}</v-btn
        >
      </li>
      <li
        class="page-item next"
        :class="{ disabled: pager.currentPage === pager.totalPages }"
        :style="liStyles"
        v-show="pager.pages.length > 1"
      >
        <v-btn
          class="page-link"
          :height="34"
          :width="34"
          fab
          small
          color="white"
          @click="changePage(pager.currentPage + 1)"
          :disabled="pager.currentPage === pager.totalPages"
          :style="aStyles"
        >
          <v-icon small color="rgba(0, 0, 0, 0.54)">fa-chevron-right</v-icon>
        </v-btn>
      </li>
      <li
        class="page-item last"
        :class="{ disabled: pager.currentPage === pager.totalPages }"
        :style="liStyles"
        v-show="pager.pages.length > 1"
      >
        <v-btn
          class="ml-2"
          :height="34"
          :width="34"
          fab
          small
          color="white"
          @click="changePage(pager.totalPages)"
          :disabled="pager.currentPage === pager.totalPages"
          :style="aStyles"
        >
          <v-icon small color="rgba(0, 0, 0, 0.54)">fa-chevron-right</v-icon>
          <v-icon small color="rgba(0, 0, 0, 0.54)">fa-chevron-right</v-icon>
        </v-btn>
      </li>
    </ul>
  </div>
</template>

<script>
import paginate from "jw-paginate";

const defaultLabels = {
  first: "First",
  last: "Last",
  previous: "Previous",
  next: "Next",
};

const defaultStyles = {
  ul: {
    margin: 0,
    padding: 0,
    display: "inline-block",
  },
  li: {
    listStyle: "none",
    display: "inline",
    textAlign: "center",
  },
  a: {
    cursor: "pointer",
    padding: "6px 12px",
    display: "block",
    float: "left",
  },
};

export default {
  props: {
    pageCount: {
      type: Number,
      required: true,
    },
    dontSetInitialPage: {
      type: Boolean,
      default: false,
    },
    initialPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 12,
    },
    maxPages: {
      type: Number,
      default: 5,
    },
    labels: {
      type: Object,
      default: () => defaultLabels,
    },
    styles: {
      type: Object,
    },
    disableDefaultStyles: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pager: {},
      ulStyles: {},
      liStyles: {},
      aStyles: {},
    };
  },
  watch: {
    pageCount: function () {
      if (!this.dontSetInitialPage) {
        this.$emit("changePage", 1);
        this.setPage(this.initialPage);
      }
    },
    pageSize: function () {
      console.log("1111");
      this.$emit("changePage", 1);
      this.setPage(this.initialPage);
    },
  },
  created() {
    if (!this.$listeners.changePage) {
      throw 'Missing required event listener: "changePage"';
    }

    // set default styles unless disabled
    if (!this.disableDefaultStyles) {
      this.ulStyles = defaultStyles.ul;
      this.liStyles = defaultStyles.li;
      this.aStyles = defaultStyles.a;
    }

    // merge custom styles with default styles
    if (this.styles) {
      this.ulStyles = { ...this.ulStyles, ...this.styles.ul };
      this.liStyles = { ...this.liStyles, ...this.styles.li };
      this.aStyles = { ...this.aStyles, ...this.styles.a };
    }

    // // set page if items array isn't empty
    this.setPage(this.initialPage);
  },
  methods: {
    setPage(page) {
      const { pageCount, pageSize, maxPages } = this;

      // get new pager object for specified page
      const pager = paginate(pageCount, page, pageSize, maxPages);
      // get new page of items from items array

      // update pager
      this.pager = pager;
    },
    changePage(e) {
      this.setPage(e);
      // emit change page event to parent component
      this.$emit("changePage", this.pager.currentPage);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--disabled {
  color: white !important;
}
.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: white !important;
}
</style>